import { useAppSelector } from "store"

export const getReservePhoneModalCurrentStepSelector = () => useAppSelector(state => state.reservePhone.currentStep)

export const getReservePhoneModalTempPhoneSelector = () => useAppSelector(state => state.reservePhone.tempPhone)

export const getReservePhoneModalPhoneSelector = () => useAppSelector(state => state.reservePhone.phone)

export const getReservePhoneModalStatusSelector = () => useAppSelector(state => state.reservePhone.opened)